<template>
    <div id="konfigurator-narozeniny">

        <h1>Zadejte věk svého psa</h1>

        <div v-show="(!isValidYear() || !isValidMonth() || !isValidDay()) && this.tryEscape" class="info-messages-box">
            <div v-if="(!isValidYear() || !isValidMonth() || !isValidDay()) && this.tryEscape" class="error-msg">Musíte vybrat počet roků a měsíců nebo kompletní datum narození</div>
        </div>

        <div class="form-content">

            <div class="stari-items">

                <div class="stari-item">
                    <div class="form-type-select">
                        <label>Roků</label>
                        <div class="select-content">
                            <select class="form-select" v-model="mazlicek.narozeniny.vypocetRok"
                                    @change="onChangeVypocet">
                                <option :key="key" v-for="(item, key) in vypocetRokyItems" v-bind:value="item.value">{{ item.label }}
                                </option>
                            </select>
                            <!--<v-select :options="vypocetRokyItems" :value="mazlicek.narozeniny.vypocetRok" :on-change="onChangeVypocet">
                            </v-select>-->
                        </div>
                    </div>
                </div>
                <div class="stari-item">
                    <div class="form-type-select">
                        <label>Měsíců</label>
                        <div class="select-content">
                            <select class="form-select" v-model="mazlicek.narozeniny.vypocetMesic"
                                    @change="onChangeVypocet">
                                <option :key="key" v-for="(item, key) in vypocetMesiceItems" v-bind:value="item.value">{{ item.label }}
                                </option>
                            </select>
                            <!--<v-select :options="vypocetMesiceItems" :value="mazlicek.narozeniny.vypocetMesic" :on-change="onChangeVypocet">
                            </v-select>-->
                        </div>
                    </div>
                </div><!-- /.col-md-6 -->

            </div><!-- /.row -->

            <p>nebo datum narození</p>

            <div class="narozeniny-items">

                <div class="narozeniny-item">
                    <div class="form-type-select"
                         v-bind:class="{ 'has-error':!isValidDay() && this.tryEscape,'has-success':isValidDay() }">
                        <label>Den</label>
                        <div class="select-content">
                            <select class="form-select" v-model="mazlicek.narozeniny.narozeniDen"
                                    @change="onChangeNarozeniny">
                                <option :key="key" v-for="(item, key) in narozeniDenItems" v-bind:value="item.value">{{ item.label }}
                                </option>
                            </select>
                            <!--<vue-select class="vue-select3" name="select3" :options="narozeniDenItems" :model.sync="mazlicek.narozeniny.narozeniDen"-->
                            <!--:onChange="onChangeNarozeniny">-->
                            <!--</vue-select>-->
                        </div>
                    </div>
                </div><!-- /.col-md-4 -->
                <div class="narozeniny-item">
                    <div class="form-type-select"
                         v-bind:class="{ 'has-error':!isValidMonth() && this.tryEscape,'has-success':isValidMonth() }">
                        <label>Měsíc</label>
                        <div class="select-content">
                            <select class="form-select" v-model="mazlicek.narozeniny.narozeniMesic"
                                    @change="onChangeNarozeniny">
                                <option :key="key" v-for="(item, key) in narozeniMesiceItems" v-bind:value="item.value">{{ item.label }}
                                </option>
                            </select>
                            <!--<v-select :options="narozeniMesiceItems" :value="mazlicek.narozeniny.narozeniMesic" :on-change="onChangeNarozeniny">
                            </v-select>-->
                        </div>
                    </div>
                </div>
                <div class="narozeniny-item">
                    <div class="form-type-select"
                         v-bind:class="{ 'has-error':!isValidYear() && this.tryEscape,'has-success':isValidYear() }">
                        <label>Rok</label>
                        <div class="select-content">
                            <select class="form-select" v-model="mazlicek.narozeniny.narozeniRok"
                                    @change="onChangeNarozeniny">
                                <option :key="key" v-for="(item, key) in narozeniRokyItems" v-bind:value="item.value">{{ item.label }}
                                </option>
                            </select>
                            <!--<v-select :options="narozeniRokyItems" :value="mazlicek.narozeniny.narozeniRok" :on-change="onChangeNarozeniny">
                            </v-select>-->
                        </div>
                    </div>
                </div>

            </div><!-- ./row -->


        </div>

        <div v-if="isTooYoung" class="infobox">Váš pes je na Pettime ještě moc malý. Pro svou první objednávku si přijďte až mu bude alespoň 6 týdnů. Budeme se těšit!</div>

        <info :krok="4"></info>

        <confirmation-modal v-if="priceConfirmation.showModal"
                            :old-price="priceConfirmation.oldPrice" :new-price="priceConfirmation.newPrice"
                            :confirm-callback="updatePetAndQuit" @close="priceConfirmation.showModal = false"/>
        <navigace
                :showPrev="true"
                :onClickPrev="prev"
                :showNext="true"
                :disableNext="!valid || isTooYoung"
                :onClickNext="next"
                :onClickSaveAndQuit="saveAndQuit"
        ></navigace>


    </div>
</template>

<script>
    import {validationMixin} from 'vuelidate'
    import {required} from 'vuelidate/lib/validators'
    import moment from 'moment'
    import navigace from './Navigace'
    import info from './Info'
    import ConfirmationModal from "./ConfirmationModal";

    export default {
        components: {
            navigace,
            info,
            ConfirmationModal
            // "vue-select": require("../select/vue-select2.js")
            // vSelect
        },
        mixins: [validationMixin],
        data: function () {
            return {
                mazlicek: this.$store.state.mazlicek,
                tryEscape: false,
                model: null,
                priceConfirmation: {
                    showModal: false,
                    differentPrice: false,
                    oldPrice: 0,
                    newPrice: 0,
                }
            }
        },
        computed: {
            valid: function () {
                return (this.mazlicek.narozeniny.valid = !this.$v.mazlicek.narozeniny.$invalid)
            },
            formatDatumNarozeni: function () {
                return moment(this.mazlicek.narozeniny.value).format('D.M.Y')
            },
            vekRoku: function () {
                return Math.floor(moment().diff(this.mazlicek.narozeniny.value, 'years', true))
            },
            vekRokuMesicu: function () {
                return Math.floor(moment().diff(this.mazlicek.narozeniny.value, 'months', true)) - this.vekRoku * 12
            },
            formatVekRoku: function () {
                return Math.round(moment().diff(this.mazlicek.narozeniny.value, 'years', true) * 100) / 100
            },
            formatVekMesicu: function () {
                return Math.round(moment().diff(this.mazlicek.narozeniny.value, 'months', true) * 100) / 100
            },
            formatVekDnu: function () {
                return Math.round(moment().diff(this.mazlicek.narozeniny.value, 'days', true) * 100) / 100
            },
            vypocetRokyItems: function () {
                var a = []
                var i = 0
                a.push({value: -1, label: 'Vyberte rok'})
                for (i = 0; i <= 50; i++) {
                    a.push({value: String(i), label: String(i)})
                }
                return a
            },
            vypocetMesiceItems: function () {
                var a = []
                var i = 0
                a.push({value: -1, label: 'Vyberte měsíc'})
                for (i = 0; i <= 12; i++) {
                    a.push({value: String(i), label: String(i)})
                }
                return a
            },
            narozeniRokyItems: function () {
                var start = new Date().getFullYear()
                var a = []
                var i = 0
                a.push({value: -1, label: 'Vyberte rok'})
                for (i = start; i >= (start - 50); i--) {
                    a.push({value: String(i), label: String(i)})
                }
                return a
            },
            narozeniMesiceItems: function () {
                var a = []
                var i = 0
                a.push({value: -1, label: 'Vyberte měsíc'})
                for (i = 1; i <= 12; i++) {
                    a.push({value: String(i), label: String(i)})
                }
                return a
            },
            narozeniDenItems: function () {
                var a = []
                var i = 0
                a.push({value: -1, label: 'Vyberte den'})
                for (i = 1; i <= 31; i++) {
                    a.push({value: String(i), label: String(i)})
                }
                return a
            },
            isTooYoung(){
                if(this.mazlicek.narozeniny.value){
                   return moment().diff(this.mazlicek.narozeniny.value, 'days') / 7.0 < 6
                } else {
                   return false
                }
            },
        },
        methods: {
            onChangeVypocet: function () {
                if (this.mazlicek.narozeniny.vypocetRok !== -1 && this.mazlicek.narozeniny.vypocetMesic !== -1) {
                    var ret = (moment().subtract(this.mazlicek.narozeniny.vypocetRok, 'years').subtract(this.mazlicek.narozeniny.vypocetMesic, 'months'))
                    this.mazlicek.narozeniny.narozeniRok = ret.year()
                    this.mazlicek.narozeniny.narozeniMesic = ret.month() + 1
                    this.mazlicek.narozeniny.narozeniDen = moment().dates()
                    this.mazlicek.narozeniny.value = moment().year(this.mazlicek.narozeniny.narozeniRok).month(this.mazlicek.narozeniny.narozeniMesic - 1).date(this.mazlicek.narozeniny.narozeniDen)
                } else {
                    this.mazlicek.narozeniny.narozeniRok = -1
                    this.mazlicek.narozeniny.narozeniMesic = -1
                    this.mazlicek.narozeniny.narozeniDen = -1
                    this.mazlicek.narozeniny.value = null
                }
            },
            onChangeNarozeniny: function () {
                if (this.mazlicek.narozeniny.narozeniRok !== -1 && this.mazlicek.narozeniny.narozeniMesic !== -1 && this.mazlicek.narozeniny.narozeniDen !== -1) {
                    this.mazlicek.narozeniny.value = moment().year(this.mazlicek.narozeniny.narozeniRok).month(this.mazlicek.narozeniny.narozeniMesic - 1).date(this.mazlicek.narozeniny.narozeniDen)
                    this.mazlicek.narozeniny.vypocetRok = this.vekRoku
                    this.mazlicek.narozeniny.vypocetMesic = this.vekRokuMesicu
                } else {
                    this.mazlicek.narozeniny.vypocetRok = -1
                    this.mazlicek.narozeniny.vypocetMesic = -1
                    this.mazlicek.narozeniny.value = null
                }
            },
            setBirthDay() {
                this.onChangeNarozeniny()
            },
            prev: function () {
                this.$router.push({name: 'rasa'})
            },
            updatePetAndQuit: function () {
                this.mazlicek.confirmToSave = false
                this.$store.dispatch('updatePet', this.mazlicek)
                  .then(response => {
                    this.$cookies.set('show_confirmation_message', 1)
                    window.location.href = 'opet-objednej/' + this.mazlicek.nid
                  }, error => {
                    console.error(error)
                  })
            },
            saveAndQuit: function () {
              if (this.isvalidstep() && !this.isTooYoung) {
                this.mazlicek.confirmToSave = true
                this.$store.dispatch('updatePet', this.mazlicek)
                  .then(response => {
                    this.mazlicek.jeStene = response.data.data.updatedNode.field_mazlicek_je_stene.und && response.data.data.updatedNode.field_mazlicek_je_stene.und[0].value == '1'

                    const confirmation = response.data.data.priceConfirmation;
                    if (confirmation && confirmation.differentPrice) {
                        this.priceConfirmation.oldPrice = confirmation.oldPrice;
                        this.priceConfirmation.newPrice = confirmation.newPrice;
                        this.priceConfirmation.showModal = true
                    } else {
                        this.updatePetAndQuit()
                    }
                  }, error => {
                    console.error(error)
                  })
              } else {
                this.tryEscape = true
                this.animateAfterError()
              }
            },
            next: function () {
                // this.$store.commit('setMazlicek', this.mazlicek)
                if (this.isvalidstep() && !this.isTooYoung) {
                    this.$store.dispatch('updatePet', this.mazlicek)
                        .then(response => {
                            this.mazlicek.jeStene = response.data.data.updatedNode.field_mazlicek_je_stene.und && response.data.data.updatedNode.field_mazlicek_je_stene.und[0].value == '1'

                            this.$router.push({name: 'pohlavi'})
                        }, error => {
                            console.error(error)
                        })
                } else {
                    this.tryEscape = true
                    this.animateAfterError()
                }
            },
            isValidYear: function () {
                return this.mazlicek.narozeniny.narozeniRok !== -1
            },
            isValidMonth: function () {
                return this.mazlicek.narozeniny.narozeniMesic !== -1
            },
            isValidDay: function () {
                return this.mazlicek.narozeniny.narozeniDen !== -1
            },
            isvalidstep: function () {
                return this.isValidYear() && this.isValidMonth() && this.isValidDay()
            },
            animateAfterError(){
                jQuery('html, body').animate({
                        scrollTop: jQuery('.app-content-left').offset().top - jQuery('#primary').height()
                    },
                    '500'
                )
            }
        },
        validations: {
            mazlicek: {
                narozeniny: {
                    value: {
                        required,
                        valid: function () {
                            return moment(this.mazlicek.narozeniny.value).isValid()
                        }
                    }
                }
            }
        },
        mounted: function () {
          // TODO: nacitani hodnot pri refreshi
            this.mazlicek.step.current = 3
            this.$cookies.set('lastVisitedStep', 3)
            jQuery('html, body').animate({scrollTop: 0}, '500')
            if (this.$store.state.mazlicek.narozeniny.value !== null) {
                let petDate = this.$store.state.mazlicek.narozeniny.value

                this.mazlicek.narozeniny.narozeniRok = petDate.year()
                this.mazlicek.narozeniny.narozeniMesic = petDate.month() + 1
                this.mazlicek.narozeniny.narozeniDen = petDate.date()

                this.setBirthDay()
            } else {
                this.mazlicek.narozeniny.vypocetRok = -1
                this.mazlicek.narozeniny.vypocetMesic = -1
                this.mazlicek.narozeniny.narozeniDen = -1
                this.mazlicek.narozeniny.narozeniMesic = -1
                this.mazlicek.narozeniny.narozeniRok = -1
            }
        },
        watch: {
            'mazlicek.narozeniny.value': {
                deep: true,
                handler: function (moment) {
                    if (this.mazlicek.narozeniny.narozeniRok === -1) {
                        this.mazlicek.narozeniny.narozeniRok = moment.year()
                        this.mazlicek.narozeniny.narozeniMesic = moment.month() + 1
                        this.mazlicek.narozeniny.narozeniDen = moment.date()
                        this.setBirthDay()
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// 04Narozeniny.vue?5cdcd8e4